// Surfaces JavaScript failures to the user instead of leaving a widget
// silently broken. Choices.js-enhanced fields (searchable selects, city
// lookup, etc.) require JS to be interactive at all, so a failure here
// otherwise looks like "nothing happens when I click."
function showJsErrorBanner(message) {
  const hook = document.getElementById('flash_hook');
  if (!hook || hook.querySelector('.js-error-banner')) return;

  const banner = document.createElement('div');
  banner.className = 'alert alert-danger alert-dismissible fade show js-error-banner';
  banner.setAttribute('role', 'alert');
  banner.innerHTML = `${message}
    <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>`;
  hook.appendChild(banner);
}

function reportJsFailure(message, error) {
  showJsErrorBanner(message);
  if (window.Sentry && typeof window.Sentry.captureException === 'function') {
    window.Sentry.captureException(error instanceof Error ? error : new Error(message));
  } else if (window.console) {
    console.error(message, error);
  }
}

export { showJsErrorBanner, reportJsFailure };
